import type { ExtractPropTypes } from "vue";

export interface ModulesData {
    type: string;
    name: string;
    labels: ModulesLabel[];
    cyagen?: string;
    product: boolean;
    name_zh?: string;
    fullName: string;
    nicknames: string[];
}

export interface ModulesLabel {
    name: string;
    data: any;
}

export interface ModulesNavigation {
    visible: boolean;
    index: number;
    name: string;
    ref?: any;
}

export const ModulesPropsOption = {
    top: { type: Number },
    mode: { type: String, required: true },
    data: { type: Object as PropType<ModulesData>, required: true },
    cover: { type: String, default: "https://rdgta.cdn.cyagen.com/rddc/pictures/3cd1d9db-5cf1-49cb-b945-c462bffb8d43.webp" },
    navigations: { type: Array as PropType<ModulesNavigation[]>, default: [] },
} as const;

export type ModulesProps = ExtractPropTypes<typeof ModulesPropsOption>;
